import { Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { NavigationError, Router } from '@angular/router';

@Injectable({providedIn: 'root'})
export class NavigationService {

    constructor(
        private router: Router,
        private settingsService: SettingsService,
    ) {}

    /**
     * Observa e trata os erros de navegação redirecionando o cliente corretamente
     * Uso ideal para a resolução de rotas entre os diversos sistemas segregados
     */
    public handleNavigationError() {

        return this.router.events
            .filter((event) => event instanceof NavigationError)
            .filter((event: NavigationError) => event.error.message.includes('Cannot match any routes'))
            .map((event: NavigationError) => {

                return window.location.hostname.includes('toroinvestimentos.com.br')
                    // Em ambientes de DEV, HML e PRD, apenas eviar para a /
                    ? event.url
                    // Em demais ambientes (provaveis locais) usar a URL base no environment
                    : `${this.settingsService.getConfigurationKeyValue('eu')}${event.url}`;

            })
            .subscribe((url) => window.location.href = url);

    }

}
